<template lang="pug">
.card
	.card-header
		h2(v-if="today==popoverDate") Eventos de hoy
		h2(v-else) Eventos de {{ popoverDate }}
	.card-body
		p(v-if="events.length == 0") No hay eventos hoy
		.table-responsive(v-else)
			table.table
				tbody
					tr(v-for="event in events")
						td(:style="{'background-color': event.color}")
						td {{ event.startHour }} - {{ event.endHour }}
						td {{ event.title }}
						td {{ event.description }}
						td 
							button.btn.btn-sm.btn-warning(@click="edit(event)")
								span.fa.fa-edit
						td
							button.btn.btn-sm.btn-danger(@click="remove(event)")
								span.fa.fa-trash
</template>

<script>
import axios from 'axios'
export default {
	props: {
		popoverDate: String
	},
	data () {
		return {
			events: [],
			today: null
		}
	},
	created () {
		this.getEvents()
		let fechaCompleta = new Date()
		let month = fechaCompleta.getMonth() + 1
		this.today = fechaCompleta.getFullYear() + '-' + month + '-' + fechaCompleta.getDate()
	},
	methods: {
		getEvents () {
			axios.get('muro/php/lib/eventos/getTodayEvents.php?today=' + this.popoverDate)
				.then(res => {
					this.events = res.data
				})
				.catch(e => {
					this.$error(e)
				})
		},
		edit (e) {
			this.$emit('edit', e)
		},
		remove (e) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar evento',
				mensaje: `¿Seguro que quieres eliminar este evento?`,
				callback: acepta => {
					if (acepta) {
						this.$emit('remove', e)
					}
				}
			})
		}
	},
	watch: {
		popoverDate () {
			this.getEvents()
		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/calendario/today.vue